import angular from 'angular';
import htmlTemplate from './nwf-parameter-page.html';

export default angular
  .module('swoa.admin.nwf-parameter.page', [])
  .component('swoaNwfParameterPage', {
    template: htmlTemplate,
    bindings: {
      currentTab: '<',
    },
    controllerAs: 'vm',
  })
  .name;
